"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "g9629",
    transform: "translate(0.01230145,0.04609203)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
      id: "text9076",
      y: "15",
      x: "3.5",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "10px",
      fontFamily: "sans-serif",
      letterSpacing: "0px",
      wordSpacing: "0px",
      fill: "currentColor",
      fillOpacity: "1",
      stroke: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tspan", {
        y: "15",
        x: "3.5",
        id: "tspan9074",
        children: "!@#"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      r: "10.079321",
      cy: "11.953908",
      cx: "11.987699",
      id: "path9078",
      fill: "none",
      fillOpacity: "1",
      stroke: "currentColor",
      strokeWidth: "1.84135818",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      strokeDashoffset: "0",
      strokeOpacity: "1",
      paintOrder: "normal"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "path9623",
      d: "M 5.2846715,4.5547445 18.919708,19.270073",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      strokeOpacity: "1"
    })]
  })
}));